import React, {useCallback, useState} from 'react';
import {IStationLoginInfo} from '../../../../../react_query/player_device_details/ListStationDevices';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  OutlinedInput,
  Typography,
} from '@mui/material';
import {CopyAll} from '@mui/icons-material';
import {UserCanAny} from '../../../../../components/UserCan';
import {DialogClose} from '../../../../../components/dialogs/DialogFrame/DialogClose';
import Toast from '../../../../../package/Toaster';

export const StationLoginInfoBtn = ({
  stationLoginInfo,
}: {
  stationLoginInfo: IStationLoginInfo;
}) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <UserCanAny scope='is-admin,station:credentials'>
      <>
        <Button variant='outlined' onClick={() => setOpen(true)}>
          Login info
        </Button>

        {open && (
          <StationLoginInfoDialog
            open={open}
            setOpen={setOpen}
            stationLoginInfo={stationLoginInfo}
          />
        )}
      </>
    </UserCanAny>
  );
};

export const StationLoginInfoDialog = ({
  stationLoginInfo,
  open,
  setOpen,
}: {
  stationLoginInfo: IStationLoginInfo;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(
      `${stationLoginInfo.name}\n${stationLoginInfo.password}`,
    );
    Toast('Copied to clibboard', 'success');
  }, [stationLoginInfo.name, stationLoginInfo.password]);

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth='sm'>
      <DialogTitle
        sx={{m: 0, display: 'flex', justifyContent: 'space-between'}}>
        <Typography className='alignCenter'>Login info</Typography>
        <DialogClose onClose={() => setOpen(false)} />
      </DialogTitle>
      <DialogContent dividers sx={{padding: 5}}>
        <FormControl fullWidth variant='outlined'>
          <InputLabel htmlFor='outlined-adornment-username'>
            username
          </InputLabel>
          <OutlinedInput
            id='outlined-adornment-username'
            type='text'
            value={stationLoginInfo.name}
            label='username'
          />
        </FormControl>
        <FormControl fullWidth variant='outlined'>
          <InputLabel htmlFor='outlined-adornment-password'>
            password
          </InputLabel>
          <OutlinedInput
            id='outlined-adornment-password'
            type='text'
            value={stationLoginInfo.password}
            label='password'
          />
        </FormControl>
      </DialogContent>
      <DialogActions className='flex items-center justify-center'>
        <Button
          startIcon={<CopyAll />}
          variant='contained'
          className='mt-2'
          onClick={handleCopy}>
          Copy
        </Button>
      </DialogActions>
    </Dialog>
  );
};
